module.exports = __webpack_public_path__ + "media/images/flags/64/Uganda-1b26effb1aeba2bf1ed0ff57ec95738b.png";